<template>
<v-container>
  <v-card>
    <v-text-field
      class="pa-3 ma-3"
      v-model="search"
      append-icon="search"
      label="Поиск по документам"
      single-line
    ></v-text-field>
    <v-card-text class="text-xs-left pa-3 ma-3"   v-for="item, i in templates" >
      <v-layout row class=" pa-0 ma-0" wrap>
        <v-flex md6>
          <v-card-text class=" pa-0 ma-0">{{item.name}}</v-card-text>
        </v-flex>
        <v-flex md6>
          <a target="_blank"  :href="item.document"><v-icon>description</v-icon>Ссылка на файл</a>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-divider class="pa-2"></v-divider>
  <v-layout align-space-around justify-center row fill-height>
    <div class="text-xs-center">
      <v-pagination
        v-model="page"
        :length="pageLength"
      ></v-pagination>
    </div>
      <v-select
        style="max-width: 70px"
      solo
        v-model="maxElem"
        :items="[10,15,30]"
      ></v-select>
  </v-layout>
  </v-card>
</v-container>
</template>

<script>
    import urls from "../../../modules/petition/urls"
    import {makeGetRequest, makePostRequestFile} from "../../../helper";
    export default {
        name: "TemplatesDocs",
        URL_LIST: urls.getUrl('admin|core|models|document_template-list', 'list'),
        data() {
            return {
                page: 1,
                total: 0,
                maxElem: 10,
                search: '',
                templates: [],

            }
        },
        computed: {
            // геттер вычисляемого значения
            pageLength: function () {
                if (this.total < this.maxElem)
                    return 1
                else
                    return Math.ceil(this.total / this.maxElem)
            }
        },

        watch: {
            maxElem:{
                handler() {
                    this.getItems()
                },
                deep: true
            },
            page: {
                handler() {
                    this.getItems()
                },
                deep: true
            },
            search: {
                handler() {
                    if(this.page <= 1)
                      this.getItems()
                    else
                      this.page = 1
                },
                // deep: true
            }
        },
        methods:{
            getItems() {
                this.loading = true

                let url = urls.getUrl('admin|core|models|document_template-list', 'list')
                let urlsci = new URL(url)
                let params = {};
                params.page =  this.page;
                params.page_size =  this.maxElem;
                if(this.search.length !== 0)
                    params.name__icontains = this.search
                urlsci.search = new URLSearchParams(params).toString();

                makeGetRequest(urlsci).then(resp => {
                    if (!resp.ok) {
                        sys = false
                    }
                    return resp.json()
                }).then(json => {
                    this.templates = json.results
                    this.total = json.count
                    this.loading = false
                })
            },

        },
        created() {
            this.getItems()
            this.$store.commit('mainpage/changeTitle', 'Шаблоны документов');
        }
    }
</script>

<style scoped>

</style>
